import React from 'react';
import './Loading.css';

function Loading({ message = "Carregando..." }) {
  return <div className="loading-container">{message}</div>;
}

export default Loading;